export const blockIconsPlacesFoodBank = (
	<span className='material-symbols-outlined'>food_bank</span>
);
